import { cn } from "@/lib/utils"

export function Card({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <article className={cn("relative rounded-lg bg-card p-6 text-card-foreground shadow-none", className)}>
      {children}
    </article>
  )
}